import { getGlobalStateUtils } from 'svs-utils/react';

var initialGlobalState = {
    dbInfo: {
        locations: {},
        wings: {},
        paramotors: {},
        engines: {},
    },
};
export var { GlobalStateProvider, useStateSlice } = getGlobalStateUtils(initialGlobalState);
